import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { Accelerator } from './components/Accelerator';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { BottomPricing } from './components/BottomPricing';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '980793120943222');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=980793120943222&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const testimonials1 = [{
    initials: 'MF',
    name: 'María F.',
    location: 'Buenos Aires | Psicóloga en Consultorio Propio',
    text: 'Organicé todo el año en una tarde. Tengo cada sesión pensada por cuadro clínico y por objetivo terapéutico. Ya no busco nada los domingos ni improviso en la semana.'
  }, {
    initials: 'JC',
    name: 'Jorge C.',
    location: 'Rosario | Psicólogo en Centro de Salud',
    text: '300 intervenciones listas, organizadas por área y objetivo clínico. Mis pacientes avanzan sesión a sesión y se nota. Nunca más llego sin saber qué hacer.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Córdoba | Psicóloga Independiente',
    text: 'Adapto el mismo material a distintos pacientes en 5 minutos. Los informes para obras sociales que antes me llevaban 3 horas, ahora los tengo en 20 minutos.'
  }];
  const testimonials2 = [{
    initials: 'MF',
    name: 'María F.',
    location: 'Buenos Aires | Psicóloga en Consultorio Propio',
    text: 'Compré un domingo a la noche. El lunes ya tenía todo el año organizado por cuadro clínico y por objetivo terapéutico. Los protocolos de ansiedad del Tomo 2 son exactamente lo que necesitaba para mis pacientes más complejos. Ya no improviso nada, nunca más.'
  }, {
    initials: 'JC',
    name: 'Jorge C.',
    location: 'Rosario | Psicólogo en Centro de Salud',
    text: 'El Tomo 3 de Depresión me cambió la práctica. El primer mes, tres pacientes lograron avances que llevaban meses estancados. Los informes del Bono 1 hacen que mis presentaciones a Obras Sociales sean completamente profesionales.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Córdoba | Psicóloga Independiente',
    text: 'El Tomo 4 de Vínculos es único en el mercado argentino. Mis pacientes con dificultades vinculares ahora tienen progresión real y lo sienten sesión a sesión. Antes armarme ese material me llevaba semanas enteras de domingos.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    location: 'Tucumán | Psicólogo en Consultorio y Obra Social',
    text: 'El sistema de evaluación con criterios objetivos eliminó la incertidumbre sobre el progreso de cada paciente. Ahora los pacientes ven el avance sesión a sesión. Y cuando ven resultados reales, el honorario deja de ser un problema.'
  }];
  return <div className="min-h-screen bg-dark text-slate-900 selection:bg-brand selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials testimonials={testimonials1} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Bonuses data-id="element-6" />

      <section className="py-8 px-4 text-center bg-dark-card border-y border-dark-border" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-9">
            ⏰ PRECIO DE LANZAMIENTO CIERRA EN:
          </div>
          <CountdownTimer data-id="element-10" />
          <div className="mt-4 flex items-center justify-center space-x-2" data-id="element-11">
            <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-12" />
            <span className="text-sm text-slate-500" data-id="element-13">
              Quedan pocos cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full max-w-md mx-auto h-2 bg-dark rounded-full mt-4 overflow-hidden border border-dark-border" data-id="element-14">
            <div className="h-full bg-brand w-[68%]" data-id="element-15" />
          </div>
          <div className="text-xs text-slate-500 mt-2" data-id="element-16">
            68% de los cupos ya tomados
          </div>
        </div>
      </section>

      <PricingTable data-id="element-17" />
      <Accelerator data-id="element-18" />

      <div className="py-8" data-id="element-19">
        <div className="text-center mb-6" data-id="element-20">
          <h2 className="text-3xl font-black ml-[20px] mr-[20px]" data-id="element-21">
            ⭐ LO QUE DICEN LAS PSICÓLOGAS QUE YA LO USAN
          </h2>
          <p className="text-slate-600 mt-2 ml-[20px] mr-[20px]" data-id="element-22">
            +500 Psicólogas de todo el país ya tienen su Ultrapack
          </p>
        </div>
        <Testimonials testimonials={testimonials2} data-id="element-23" />
      </div>

      <Guarantee data-id="element-24" />
      <FAQ data-id="element-25" />
      <CostSection data-id="element-26" />

      <BottomPricing data-id="element-27" />

      <Footer data-id="element-28" />
    </div>;
}